const translations = {
  title: 'Novo Usuário',
  title_edit: 'Editando Usuário',
  bulkEdit: 'Cadastro em massa',
  name: 'Nome',
  email: 'Email',
  profile: 'Perfil',
  groups: 'Grupos',
  productiveCapacity: 'Capacidade produtiva',
  relatedUsers: 'Usuários relacionados',
  fakeEmailQuestion: 'E-mail fictício?',
  fakeEmail: 'E-mail fictício',
  canAccessPaymentModule: 'Pode acessar módulo financeiro',
  changingPassword: 'Alterando senha de {{name}}',
  temporaryPassword: 'Senha temporária',
  temporaryPasswordConfirmation: 'Confirmação da senha temporária',
  passwordRequired: 'Senhas obrigatória',
  minCharacters: 'Minimo de {{count}} caracteres',
  passwordsDoNotMatch: 'Senhas não estão iguais',
  maxLengthExceeded: 'Tamanho maximo excedido',
  checkWorkShifts: 'Verifique os turnos de trabalho',
  successTitle: 'Cadastrado com sucesso!',
  successMessage: 'Usuário cadastrado com sucesso.'
}

export default translations
